import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import CollectionCoordinatesForm from '../Forms/CollectionCoordinatesForm';

const CollectionCoordinatesModal = ({
    isOpen,
    isEdit,
    handleToggleModal,
    dataCoordinates,
    handleSave,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={handleToggleModal}
            size='lg'
            className='border-0'
            modalClassName='modal fade zoomIn'
            backdrop={'static'}
            centered={true}
            unmountOnClose={true}
        >
            <ModalHeader toggle={handleToggleModal}>
                {isEdit ? 'Editar' : 'Agregar'} Registro de Coordenadas de Captación
            </ModalHeader>

            <CollectionCoordinatesForm
                dataCoordinates={dataCoordinates}
                isOpen={isOpen}
                isEdit={isEdit}
                handleToggleModal={handleToggleModal}
                handleSave={handleSave}
            />
        </Modal>
    );
};

export default CollectionCoordinatesModal;